"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RegionDto {
}
exports.RegionDto = RegionDto;
